// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
// @flow
/**
 * 1.2018-01-26 添加酷炫黑、活力橙、经典红、瑞丽红的自定义样式
 */

export default {
    CATEGORY_CHANNEL_OPEN_TIME: 'channel_open_time',
    CATEGORY_CHANNEL_APPROXIMATE_VIEW_TIME: 'channel_approximate_view_time',
    CATEGORY_DIRECT_CHANNEL_SHOW: 'direct_channel_show',
    CATEGORY_GROUP_CHANNEL_SHOW: 'group_channel_show',
    CATEGORY_FLAGGED_POST: 'flagged_post',
    CATEGORY_FAVORITE_CHANNEL: 'favorite_channel',
    CATEGORY_AUTO_RESET_MANUAL_STATUS: 'auto_reset_manual_status',

    CATEGORY_NOTIFICATIONS: 'notifications',

    COMMENTS: 'comments',
    COMMENTS_ANY: 'any',
    COMMENTS_ROOT: 'root',
    COMMENTS_NEVER: 'never',

    EMAIL: 'email',

    EMAIL_INTERVAL: 'email_interval',
    INTERVAL_FIFTEEN_MINUTES: 15 * 60,
    INTERVAL_HOUR: 60 * 60,
    INTERVAL_IMMEDIATE: 30, // "immediate" is a 30 second interval
    INTERVAL_NEVER: 0,

    CATEGORY_DISPLAY_SETTINGS: 'display_settings',
    NAME_NAME_FORMAT: 'name_format',
    DISPLAY_PREFER_NICKNAME: 'nickname_full_name',
    DISPLAY_PREFER_FULL_NAME: 'full_name',

    MENTION_KEYS: 'mention_keys',

    USE_MILITARY_TIME: 'use_military_time',

    CATEGORY_SIDEBAR_SETTINGS: 'sidebar_settings',

    CATEGORY_ADVANCED_SETTINGS: 'advanced_settings',
    ADVANCED_FILTER_JOIN_LEAVE: 'join_leave',

    CATEGORY_THEME: 'theme',
    THEMES: {

        //自定义样式，酷炫黑
        coolBlack: {
            type: 'Cool_Black',
            awayIndicator: '#00f29b',
            buttonBg: '#16abff',
            buttonColor: '#FFFFFF',
            centerChannelBg: '#f7f7f7',
            centerChannelColor: '#333333',
            codeTheme: 'solarized-dark',
            linkColor: '#2f81b7',
            mentionBg: '#FBFBFB',
            mentionColor: '#2071A7',
            mentionHighlightBg: '#fff2bb',
            mentionHighlightLink: '#2f81b7',
            newMessageSeparator: '#FF8800',
            onlineIndicator: '#0aa8e3',
            sidebarBg: '#1f1f1f',
            sidebarHeaderBg: '#000000',
            sidebarHeaderTextColor: '#FFFFFF',
            sidebarText: '#fff',
            sidebarTextActiveBorder: '#0aa8e3',
            sidebarTextActiveColor: '#FFFFFF',
            sidebarTextHoverBg: '#136197',
            sidebarUnreadText: '#fff',
        },

        //自定义样式，活力橙
        activeOrange: {
            type: 'Active_Orange',
            awayIndicator: '#f57c44',
            buttonBg: '#f34642',
            buttonColor: '#FFFFFF',
            centerChannelBg: '#f5f6f8',
            centerChannelColor: '#333333',
            codeTheme: 'github',
            linkColor: '#2f81b7',
            mentionBg: '#FBFBFB',
            mentionColor: '#f34642',
            mentionHighlightBg: '#fff2bb',
            mentionHighlightLink: '#f34642',
            newMessageSeparator: '#FF8800',
            onlineIndicator: '#e70500',
            sidebarBg: '#e4e4e4',
            sidebarHeaderBg: '#f34642',
            sidebarHeaderTextColor: '#ffffff',
            sidebarText: '#260100',
            sidebarTextActiveBorder: '#f34642',
            sidebarTextActiveColor: '#f34642',
            sidebarTextHoverBg: '#cbcbcb',
            sidebarUnreadText: '#f34642',
        },

        //自定义样式，经典红
        classicRed: {
            type: 'Classic_Red',
            awayIndicator: '#bd888b',
            buttonBg: '#b3232d',
            buttonColor: '#fff',
            centerChannelBg: '#f7f7f7',
            centerChannelColor: '#333333',
            codeTheme: 'github',
            linkColor: '#2f81b7',
            mentionBg: '#FBFBFB',
            mentionColor: '#b3232d',
            mentionHighlightBg: '#fff2bb',
            mentionHighlightLink: '#b2222c',
            newMessageSeparator: '#FF8800',
            onlineIndicator: '#b3232d',
            sidebarBg: '#212429',
            sidebarHeaderBg: '#b2222c',
            sidebarHeaderTextColor: '#FFFFFF',
            sidebarText: '#ffffff',
            sidebarTextActiveBorder: '#b3232d',
            sidebarTextActiveColor: '#b3232d',
            sidebarTextHoverBg: '#171717',
            sidebarUnreadText: '#b3232d',
        },

        //自定义样式，瑞丽红
        ruiliRed: {
            type: 'Ruili_Red',
            awayIndicator: '#f2570a',
            buttonBg: '#b2222c',
            buttonColor: '#FFFFFF',
            centerChannelBg: '#f7f7f7',
            centerChannelColor: '#333333',
            codeTheme: 'github',
            linkColor: '#2f81b7',
            mentionBg: '#FBFBFB',
            mentionColor: '#e60012',
            mentionHighlightBg: '#fff2bb',
            mentionHighlightLink: '#e60012',
            newMessageSeparator: '#FF8800',
            onlineIndicator: '#e60012',
            sidebarBg: '#eeeeee',
            sidebarHeaderBg: '#b2222c',
            sidebarHeaderTextColor: '#FFFFFF',
            sidebarText: '#000000',
            sidebarTextActiveBorder: '#e60012',
            sidebarTextActiveColor: '#e60012',
            sidebarTextHoverBg: '#e8e8e8',
            sidebarUnreadText: '#e60012',
        },

        default: {
            type: 'Mattermost',
            sidebarBg: '#145dbf',
            sidebarText: '#ffffff',
            sidebarUnreadText: '#ffffff',
            sidebarTextHoverBg: '#4578bf',
            sidebarTextActiveBorder: '#579eff',
            sidebarTextActiveColor: '#ffffff',
            sidebarHeaderBg: '#1153ab',
            sidebarHeaderTextColor: '#ffffff',
            onlineIndicator: '#06d6a0',
            awayIndicator: '#ffbc42',
            dndIndicator: '#f74343',
            mentionBj: '#ffffff',
            mentionColor: '#145dbf',
            centerChannelBg: '#ffffff',
            centerChannelColor: '#3d3c40',
            newMessageSeparator: '#ff8800',
            linkColor: '#2389d7',
            buttonBg: '#166de0',
            buttonColor: '#ffffff',
            errorTextColor: '#fd5960',
            mentionHighlightBg: '#ffe577',
            mentionHighlightLink: '#166de0',
            codeTheme: 'github',
        },
        organization: {
            type: 'Organization',
            sidebarBg: '#2071a7',
            sidebarText: '#ffffff',
            sidebarUnreadText: '#ffffff',
            sidebarTextHoverBg: '#136197',
            sidebarTextActiveBorder: '#7ab0d6',
            sidebarTextActiveColor: '#ffffff',
            sidebarHeaderBg: '#2f81b7',
            sidebarHeaderTextColor: '#ffffff',
            onlineIndicator: '#7dbe00',
            awayIndicator: '#dcbd4e',
            dndIndicator: '#ff6a6a',
            mentionBj: '#fbfbfb',
            mentionColor: '#2071f7',
            centerChannelBg: '#f2f4f8',
            centerChannelColor: '#333333',
            newMessageSeparator: '#ff8800',
            linkColor: '#2f81b7',
            buttonBg: '#1dacfc',
            buttonColor: '#ffffff',
            errorTextColor: '#a94442',
            mentionHighlightBg: '#f3e197',
            mentionHighlightLink: '#2f81b7',
            codeTheme: 'github',
        },
        mattermostDark: {
            type: 'Mattermost Dark',
            sidebarBg: '#1b2c3e',
            sidebarText: '#ffffff',
            sidebarUnreadText: '#ffffff',
            sidebarTextHoverBg: '#4a5664',
            sidebarTextActiveBorder: '#66b9a7',
            sidebarTextActiveColor: '#ffffff',
            sidebarHeaderBg: '#1b2c3e',
            sidebarHeaderTextColor: '#ffffff',
            onlineIndicator: '#65dcc8',
            awayIndicator: '#c1b966',
            dndIndicator: '#e81023',
            mentionBj: '#b74a4a',
            mentionColor: '#ffffff',
            centerChannelBg: '#2f3e4e',
            centerChannelColor: '#dddddd',
            newMessageSeparator: '#5de5da',
            linkColor: '#a4ffeb',
            buttonBg: '#4cbba4',
            buttonColor: '#ffffff',
            errorTextColor: '#ff6461',
            mentionHighlightBg: '#984063',
            mentionHighlightLink: '#a4ffeb',
            codeTheme: 'solarized-dark',
        },
        windows10: {
            type: 'Windows Dark',
            sidebarBg: '#171717',
            sidebarText: '#ffffff',
            sidebarUnreadText: '#ffffff',
            sidebarTextHoverBg: '#302e30',
            sidebarTextActiveBorder: '#196caf',
            sidebarTextActiveColor: '#ffffff',
            sidebarHeaderBg: '#1f1f1f',
            sidebarHeaderTextColor: '#ffffff',
            onlineIndicator: '#399fff',
            awayIndicator: '#c1b966',
            dndIndicator: '#e81023',
            mentionBj: '#0177e7',
            mentionColor: '#ffffff',
            centerChannelBg: '#1f1f1f',
            centerChannelColor: '#dddddd',
            newMessageSeparator: '#cc992d',
            linkColor: '#0d93ff',
            buttonBg: '#0177e7',
            buttonColor: '#ffffff',
            errorTextColor: '#ff6461',
            mentionHighlightBg: '#784098',
            mentionHighlightLink: '#a4ffeb',
            codeTheme: 'monokai',
        },
    },
};
